import zoid from 'zoid';

import { decodeObject, encodeObject } from 'utils/encoding';

if (!window.flywire) {
  const embedded = zoid.create({
    tag: 'fw-payment',
    dimensions: {
      width: '100%',
      height: '800px',
    },
    url: config => {
      const urls = {
        demo: 'https://payment.demo.flywire.com/',
        local: 'http://localhost:5300/',
        app: 'http://payex/',
        production: 'https://payment.flywire.com/',
        staging: 'https://payment.flywire.lol',
      };

      const { props } = decodeObject(config);
      return urls[props.env] || `https://payex-web-dev-${props.env}.flywire.cc/checkout`;
    },
    defaultEnv: 'demo',
    scrolling: true,
    defaultLogLevel: 'error',
  });

  const embeddedAdapter = {
    Payment: {
      render: (config, selector) => {
        const encodedConfig = encodeObject(config);

        return embedded(encodedConfig).render(selector);
      },
    },
  };

  window.flywire = embeddedAdapter;
  window.requester = 'payex';
}
